<!-- 页面内容 -->
<!--新闻主页面-->
<template>
    <!-- container -->
    <div class='content'>
        <div class="container cont">
            <div class="contV">
                <div class="topA">
                    <div class="topA1">
                        <div class="LIst" v-for="(item, index) in List" :key="index" @click="goChange(item.newsId)">
                            <img class="Img" :src="item.thumbnail" alt="" />
                            <div class="Td">
                                <div class="T1">{{ item.heading }}</div>
                                <div class="T2">{{ item.subtitle }}</div>
                                <div class="T2">{{ item.text }}</div>
                                <div class="T3">{{ item.createTime }}</div>
                            </div>
                        </div>
                        <!-- <div class="LIst">
                            <img class="Img" src="" alt="" />
                            <div class="Td">
                                <div class="T1">With the violent surge in A-shares and the sharp rise of the Renminbi, is a
                                    bull market on the horizon?</div>
                                <div class="T2">In a major scientific breakthrough, tech giant XYZ has announced a
                                    significant advancement in the field of quantum computing.</div>
                                <div class="T3">2023-09-14 16:10:23</div>
                            </div>
                        </div>
                        <div class="LIst">
                            <img class="Img" src="" alt="" />
                            <div class="Td">
                                <div class="T1">With the violent surge in A-shares and the sharp rise of the Renminbi, is a
                                    bull market on the horizon?</div>
                                <div class="T2">In a major scientific breakthrough, tech giant XYZ has announced a
                                    significant advancement in the field of quantum computing.</div>
                                <div class="T3">2023-09-14 16:10:23</div>
                            </div>
                        </div>
                        <div class="LIst">
                            <img class="Img" src="" alt="" />
                            <div class="Td">
                                <div class="T1">With the violent surge in A-shares and the sharp rise of the Renminbi, is a
                                    bull market on the horizon?</div>
                                <div class="T2">In a major scientific breakthrough, tech giant XYZ has announced a
                                    significant advancement in the field of quantum computing.</div>
                                <div class="T3">2023-09-14 16:10:23</div>
                            </div>
                        </div> -->
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            List: [],
            Text: ''
        }
    },
    mounted() {
        this.listApi();
    },
    methods: {
        // 0用户协议、1隐私协议
        goChange(e) {
            this.$router.push({
                path: "/home/newsDetial",
                query: {
                    ids: e
                }
            })
        },
        // 新闻
        async listApi() {
            try {
                const res = await this.$get('system/news/list');
                this.List = res.rows || [];
                console.warn(res, "关于我们")
            } catch (error) {
            }
        },
        goForm() {
            console.warn('+++++++++')
            this.$router.push({
                path: "customizationFrom"
            })
        }
    },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>